import { PublicUser, UserRole } from '../types/auth';

/** Students must have VN mobile; admin skips. */
export function userRequiresPhone(user: PublicUser | null | undefined): boolean {
  if (!user) return false;
  const roles = user.roles || [];
  if (roles.includes(UserRole.ADMIN)) {
    return false;
  }
  return !/^0\d{9}$/.test(String(user.phone || '').trim());
}
